function drawBat(c, colour) {
    c.fillStyle = colour;
    c.fillRect(290, 390, 10, 10);
    c.fillRect(300, 390, 10, 10);
    c.fillRect(310, 390, 10, 10);
    c.fillRect(320, 390, 10, 10);
    c.fillRect(330, 390, 10, 10);
    c.fillRect(340, 390, 10, 10);
    c.fillRect(350, 390, 10, 10);
    c.fillRect(360, 390, 10, 10);

    c.fillRect(290, 380, 10, 10);
    c.fillRect(300, 380, 10, 10);
    c.fillRect(310, 380, 10, 10);
    c.fillRect(340, 380, 10, 10);
    c.fillRect(350, 380, 10, 10);
    c.fillRect(360, 380, 10, 10);

    c.fillRect(300, 370, 10, 10);
    c.fillRect(310, 370, 10, 10);
    c.fillRect(320, 370, 10, 10);
    c.fillRect(330, 370, 10, 10);
    c.fillRect(340, 370, 10, 10);
    c.fillRect(350, 370, 10, 10);

    c.fillRect(280, 360, 10, 10);
    c.fillRect(300, 360, 10, 10);
    c.fillRect(320, 360, 10, 10);
    c.fillRect(330, 360, 10, 10);
    c.fillRect(350, 360, 10, 10);
    c.fillRect(370, 360, 10, 10);

    c.fillRect(290, 350, 10, 10);
    c.fillRect(300, 350, 10, 10);
    c.fillRect(310, 350, 10, 10);
    c.fillRect(320, 350, 10, 10);
    c.fillRect(330, 350, 10, 10);
    c.fillRect(340, 350, 10, 10);
    c.fillRect(350, 350, 10, 10);
    c.fillRect(360, 350, 10, 10);

    c.fillRect(310, 340, 10, 10);
    c.fillRect(340, 340, 10, 10);

    c.fillRect(300, 330, 10, 10);
    c.fillRect(350, 330, 10, 10);

    c.fillStyle = 'white';
    c.fillRect(320, 380, 10, 10);
    c.fillRect(330, 380, 10, 10);

    c.fillRect(310, 360, 10, 10);
    c.fillRect(340, 360, 10, 10);
}

function drawDog(c, colour) {
    c.fillStyle = colour;
    c.fillRect(300, 390, 10, 10);
    c.fillRect(310, 390, 10, 10);
    c.fillRect(320, 390, 10, 10);
    c.fillRect(330, 390, 10, 10);
    c.fillRect(340, 390, 10, 10);

    c.fillRect(350, 380, 10, 10);
    c.fillRect(340, 380, 10, 10);
    c.fillRect(330, 380, 10, 10);
    c.fillRect(320, 380, 10, 10);
    c.fillRect(310, 380, 10, 10);
    c.fillRect(300, 380, 10, 10);
    c.fillRect(290, 380, 10, 10);

    c.fillRect(350, 370, 10, 10);
    c.fillRect(340, 370, 10, 10);
    c.fillRect(330, 370, 10, 10);
    c.fillRect(320, 370, 10, 10);
    c.fillRect(310, 370, 10, 10);
    c.fillRect(300, 370, 10, 10);
    c.fillRect(290, 370, 10, 10);

    c.fillRect(350, 360, 10, 10);
    c.fillRect(340, 360, 10, 10);
    c.fillRect(320, 360, 10, 10);
    c.fillRect(300, 360, 10, 10);
    c.fillRect(290, 360, 10, 10);

    c.fillRect(300, 350, 10, 10);
    c.fillRect(310, 350, 10, 10);
    c.fillRect(320, 350, 10, 10);
    c.fillRect(330, 350, 10, 10);
    c.fillRect(340, 350, 10, 10);

    c.fillRect(300, 340, 10, 10);
    c.fillRect(320, 340, 10, 10);
    c.fillRect(340, 340, 10, 10);

    c.fillStyle = 'white';
    c.fillRect(310, 360, 10, 10);
    c.fillRect(330, 360, 10, 10);
}

function drawYat(c, colour) {
    c.fillStyle = colour;
    c.fillRect(290, 390, 10, 10);
    c.fillRect(300, 390, 10, 10);
    c.fillRect(310, 390, 10, 10);
    c.fillRect(320, 390, 10, 10);
    c.fillRect(330, 390, 10, 10);
    c.fillRect(340, 390, 10, 10);
    c.fillRect(350, 390, 10, 10);
    c.fillRect(360, 390, 10, 10);

    c.fillRect(290, 380, 10, 10);
    c.fillRect(300, 380, 10, 10);
    c.fillRect(310, 380, 10, 10);
    c.fillRect(340, 380, 10, 10);
    c.fillRect(350, 380, 10, 10);
    c.fillRect(360, 380, 10, 10);

    c.fillRect(300, 370, 10, 10);
    c.fillRect(310, 370, 10, 10);
    c.fillRect(320, 370, 10, 10);
    c.fillRect(330, 370, 10, 10);
    c.fillRect(340, 370, 10, 10);
    c.fillRect(350, 370, 10, 10);

    c.fillRect(300, 360, 10, 10);
    c.fillRect(320, 360, 10, 10);
    c.fillRect(330, 360, 10, 10);
    c.fillRect(350, 360, 10, 10);

    c.fillRect(300, 350, 10, 10);
    c.fillRect(310, 350, 10, 10);
    c.fillRect(320, 350, 10, 10);
    c.fillRect(330, 350, 10, 10);
    c.fillRect(340, 350, 10, 10);
    c.fillRect(350, 350, 10, 10);

    c.fillRect(310, 340, 10, 10);
    c.fillRect(340, 340, 10, 10);

    c.fillStyle = 'white';
    c.fillRect(320, 380, 10, 10);
    c.fillRect(330, 380, 10, 10);

    c.fillRect(310, 360, 10, 10);
    c.fillRect(340, 360, 10, 10);

}

function drawDat(c, colour) {
    c.fillStyle = colour;
    c.fillRect(300, 390, 10, 10);
    c.fillRect(310, 390, 10, 10);
    c.fillRect(320, 390, 10, 10);
    c.fillRect(330, 390, 10, 10);
    c.fillRect(340, 390, 10, 10);

    c.fillRect(350, 380, 10, 10);
    c.fillRect(340, 380, 10, 10);
    c.fillRect(300, 380, 10, 10);
    c.fillRect(290, 380, 10, 10);

    c.fillRect(350, 370, 10, 10);
    c.fillRect(340, 370, 10, 10);
    c.fillRect(330, 370, 10, 10);
    c.fillRect(320, 370, 10, 10);
    c.fillRect(310, 370, 10, 10);
    c.fillRect(300, 370, 10, 10);
    c.fillRect(290, 370, 10, 10);

    c.fillRect(350, 360, 10, 10);
    c.fillRect(340, 360, 10, 10);
    c.fillRect(320, 360, 10, 10);
    c.fillRect(300, 360, 10, 10);
    c.fillRect(290, 360, 10, 10);

    c.fillRect(290, 350, 10, 10);
    c.fillRect(300, 350, 10, 10);
    c.fillRect(310, 350, 10, 10);
    c.fillRect(320, 350, 10, 10);
    c.fillRect(330, 350, 10, 10);
    c.fillRect(340, 350, 10, 10);
    c.fillRect(350, 350, 10, 10);

    c.fillRect(300, 340, 10, 10);
    c.fillRect(310, 340, 10, 10);
    c.fillRect(320, 340, 10, 10);
    c.fillRect(330, 340, 10, 10);
    c.fillRect(340, 340, 10, 10);

    c.fillRect(320, 330, 10, 10);
    c.fillRect(320, 320, 10, 10);

    c.fillStyle = 'white';
    c.fillRect(310, 380, 10, 10);
    c.fillRect(320, 380, 10, 10);
    c.fillRect(330, 380, 10, 10);

    c.fillRect(310, 360, 10, 10);
    c.fillRect(330, 360, 10, 10);
}

function drawAat(c, colour) {
    c.fillStyle = colour;
    c.fillRect(290, 390, 10, 10);
    c.fillRect(310, 390, 10, 10);
    c.fillRect(340, 390, 10, 10);
    c.fillRect(360, 390, 10, 10);

    c.fillRect(290, 380, 10, 10);
    c.fillRect(300, 380, 10, 10);
    c.fillRect(310, 380, 10, 10);
    c.fillRect(340, 380, 10, 10);
    c.fillRect(350, 380, 10, 10);
    c.fillRect(360, 380, 10, 10);

    c.fillRect(300, 370, 10, 10);
    c.fillRect(310, 370, 10, 10);
    c.fillRect(320, 370, 10, 10);
    c.fillRect(330, 370, 10, 10);
    c.fillRect(340, 370, 10, 10);
    c.fillRect(350, 370, 10, 10);

    c.fillRect(300, 360, 10, 10);
    c.fillRect(320, 360, 10, 10);
    c.fillRect(330, 360, 10, 10);
    c.fillRect(350, 360, 10, 10);

    c.fillRect(300, 350, 10, 10);
    c.fillRect(310, 350, 10, 10);
    c.fillRect(320, 350, 10, 10);
    c.fillRect(330, 350, 10, 10);
    c.fillRect(340, 350, 10, 10);
    c.fillRect(350, 350, 10, 10);

    c.fillRect(310, 340, 10, 10);
    c.fillRect(340, 340, 10, 10);

    c.fillRect(300, 330, 10, 10);
    c.fillRect(350, 330, 10, 10);

    c.fillStyle = 'white';
    c.fillRect(310, 360, 10, 10);
    c.fillRect(340, 360, 10, 10);
}

function drawPat(c, colour) {
    c.fillStyle = 'white';
    c.fillRect(290, 390, 10, 10);
    c.fillRect(300, 390, 10, 10);
    c.fillRect(310, 390, 10, 10);
    c.fillRect(350, 390, 10, 10);
    c.fillRect(360, 390, 10, 10);

    c.fillRect(290, 380, 10, 10);
    c.fillRect(300, 380, 10, 10);
    c.fillRect(310, 380, 10, 10);
    c.fillRect(350, 380, 10, 10);
    c.fillRect(360, 380, 10, 10);

    c.fillRect(290, 370, 10, 10);
    c.fillRect(300, 370, 10, 10);
    c.fillRect(310, 370, 10, 10);
    c.fillRect(320, 370, 10, 10);
    c.fillRect(330, 370, 10, 10);
    c.fillRect(340, 370, 10, 10);
    c.fillRect(350, 370, 10, 10);
    c.fillRect(360, 370, 10, 10);

    c.fillRect(290, 360, 10, 10);
    c.fillRect(300, 360, 10, 10);
    c.fillRect(310, 360, 10, 10);
    c.fillRect(320, 360, 10, 10);
    c.fillRect(330, 360, 10, 10);
    c.fillRect(340, 360, 10, 10);
    c.fillRect(350, 360, 10, 10);
    c.fillRect(360, 360, 10, 10);

    c.fillRect(290, 350, 10, 10);
    c.fillRect(300, 350, 10, 10);
    c.fillRect(310, 350, 10, 10);
    c.fillRect(320, 350, 10, 10);
    c.fillRect(330, 350, 10, 10);
    c.fillRect(340, 350, 10, 10);
    c.fillRect(350, 350, 10, 10);
    c.fillRect(360, 350, 10, 10);

    c.fillRect(280, 340, 10, 10);
    c.fillRect(290, 340, 10, 10);
    c.fillRect(300, 340, 10, 10);
    c.fillRect(310, 340, 10, 10);
    c.fillRect(320, 340, 10, 10);
    c.fillRect(330, 340, 10, 10);
    c.fillRect(340, 340, 10, 10);
    c.fillRect(350, 340, 10, 10);
    c.fillRect(360, 340, 10, 10);
    c.fillRect(370, 340, 10, 10);

    c.fillRect(290, 330, 10, 10);
    c.fillRect(300, 330, 10, 10);
    c.fillRect(310, 330, 10, 10);
    c.fillRect(320, 330, 10, 10);
    c.fillRect(330, 330, 10, 10);
    c.fillRect(340, 330, 10, 10);
    c.fillRect(350, 330, 10, 10);
    c.fillRect(360, 330, 10, 10);

    c.fillRect(300, 320, 10, 10);
    c.fillRect(310, 320, 10, 10);
    c.fillRect(320, 320, 10, 10);
    c.fillRect(330, 320, 10, 10);
    c.fillRect(340, 320, 10, 10);
    c.fillRect(350, 320, 10, 10);
    c.fillRect(360, 320, 10, 10);
    c.fillRect(370, 320, 10, 10);

    c.fillStyle = colour;
    c.fillRect(290, 390, 10, 10);
    c.fillRect(300, 390, 10, 10);
    c.fillRect(310, 390, 10, 10);
    c.fillRect(350, 390, 10, 10);
    c.fillRect(360, 390, 10, 10);

    c.fillRect(280, 380, 10, 10);
    c.fillRect(320, 380, 10, 10);
    c.fillRect(330, 380, 10, 10);
    c.fillRect(340, 380, 10, 10);
    c.fillRect(370, 380, 10, 10);

    c.fillRect(280, 370, 10, 10);
    c.fillRect(370, 370, 10, 10);

    c.fillRect(290, 360, 10, 10);
    c.fillRect(310, 360, 10, 10);
    c.fillRect(320, 360, 10, 10);
    c.fillRect(360, 360, 10, 10);

    c.fillRect(270, 350, 10, 10);
    c.fillRect(290, 350, 10, 10);
    c.fillRect(360, 350, 10, 10);
    c.fillRect(380, 350, 10, 10);

    c.fillRect(280, 340, 10, 10);
    c.fillRect(340, 340, 10, 10);
    c.fillRect(370, 340, 10, 10);

    c.fillRect(290, 330, 10, 10);
    c.fillRect(310, 330, 10, 10);
    c.fillRect(360, 330, 10, 10);

    c.fillRect(300, 320, 10, 10);
    c.fillRect(360, 320, 10, 10);
    c.fillRect(370, 320, 10, 10);

    c.fillRect(300, 310, 10, 10);
    c.fillRect(310, 310, 10, 10);
    c.fillRect(320, 310, 10, 10);
    c.fillRect(330, 310, 10, 10);
    c.fillRect(340, 310, 10, 10);
    c.fillRect(350, 310, 10, 10);
    c.fillRect(360, 310, 10, 10);
    c.fillRect(370, 310, 10, 10);

    c.fillRect(280, 300, 10, 10);
    c.fillRect(290, 300, 10, 10);
    c.fillRect(300, 300, 10, 10);
    c.fillRect(310, 300, 10, 10);
    c.fillRect(320, 300, 10, 10);
    c.fillRect(330, 300, 10, 10);
    c.fillRect(340, 300, 10, 10);
    c.fillRect(350, 300, 10, 10);
    c.fillRect(360, 300, 10, 10);
    c.fillRect(370, 300, 10, 10);

}

function drawEmpty(c, colour) {}

var pets = {
    bat: drawBat,
    dog: drawDog,
    yat: drawYat,
    dat: drawDat,
    aat: drawAat,
    pat: drawPat,
    empty: drawEmpty
}

export {pets as default};